import { redirect, RedirectType } from 'next/navigation';

// Href of a react-router `to` prop, which can be either a string
// ("/path?query#hash") or a location-like object ({ pathname, search, hash }).
const getHref = to => {
  if (typeof to === 'string') return to;
  if (to && typeof to === 'object') {
    const { pathname = '', search = '', hash = '' } = to;
    const searchWithPrefix =
      search && !search.startsWith('?') ? `?${search}` : search;
    return `${pathname}${searchWithPrefix}${hash}`;
  }
  return '';
};

// React Router v5 <Redirect> navigates as soon as it renders: replace by
// default, push when the `push` prop is set. Components use it as a guard
// (e.g. withLoginPage returns <Redirect to="/sign-in/..." /> for logged-out
// users on pages the proxy doesn't protect, like /tracking/), so it must
// actually navigate — rendering nothing instead strands the user on a blank
// page.
//
// The navigation happens during render via next/navigation's redirect()
// (which throws and lets Next's redirect boundary perform the route change),
// NOT in a useEffect: the App Router revives cached page trees on repeat
// navigations without re-rendering them first, and a mount effect on a
// stale, no-longer-rendered <Redirect> fiber re-fires during that reveal and
// cancels the in-flight navigation (observed as login → /tracking/ bouncing
// straight back to /sign-in/). A render-phase redirect can only fire when
// the current render actually chose to show <Redirect>.
const RedirectMock = ({ to, push = false }) => {
  const href = getHref(to);

  if (!href) {
    return null;
  }

  // redirect() throws; returning it satisfies consistent-return.
  return redirect(href, push ? RedirectType.push : RedirectType.replace);
};

export default RedirectMock;
